import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";

import {
    ICreateSavedFilterRequestDTO,
    IGetSavedListingFiltersResponseDTO,
    IUpdateSavedFilterRequestDTO,
    IUpdateSavedFilterResponseDTO
} from "./save-filters.dto";

@Injectable({
    providedIn: 'root'
})
export class SaveFilterApiService {

    constructor(private http: HttpClient) {
    }

    list(): Observable<IGetSavedListingFiltersResponseDTO[]> {
        return this.http.get<IGetSavedListingFiltersResponseDTO[]>(`filters`);
    }

    create(data: ICreateSavedFilterRequestDTO): Observable<IGetSavedListingFiltersResponseDTO> {
        return this.http.post<IGetSavedListingFiltersResponseDTO>(`filters`, data);
    }

    update(filterId: number, data: IUpdateSavedFilterRequestDTO): Observable<IUpdateSavedFilterResponseDTO> {
        return this.http.put<IUpdateSavedFilterResponseDTO>(`filters/${filterId}`, data);
    }

    delete(filterId: number) {
        return this.http.delete(`filters/${filterId}`);
    }
}
